import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import {
  getTrend,
  getTrendColor,
  cardStyle,
  titleStyle,
  valueContainerStyle,
  prevMonthContainerStyle,
  arrowStyle,
  prevMonthInfoStyle,
  currentMonthValueStyle,
} from './stat-card-utils'

/**
 * 回答率カードコンポーネント
 * 現在月の回答率と前月比を表示
 */
type Props = {
  title: string
  currentMonthValue: number
  momRate?: number
  prevMonthAnswerRate?: number
}

export const AnswerRateCard = ({ title, currentMonthValue, momRate, prevMonthAnswerRate }: Props) => {
  const { t } = useTranslation()

  const prevMonthValue: string = useMemo(() => {
    if (prevMonthAnswerRate === undefined) {
      return '-'
    }
    return `${prevMonthAnswerRate.toFixed(1)}%`
  }, [prevMonthAnswerRate])

  const currentMonthValueDisplay: string = useMemo(() => {
    return `${currentMonthValue}%`
  }, [currentMonthValue])

  const momRateDisplay: string = useMemo(() => {
    if (momRate === undefined) {
      return '-'
    }
    // 回答率の前月比はポイント（pt）単位で表示
    return `${momRate}pt`
  }, [momRate])

  const trend = useMemo(() => getTrend(momRate), [momRate])
  const trendColor = useMemo(() => getTrendColor(trend), [trend])
  const trendColorStyle = useMemo(() => css({ color: trendColor }), [trendColor])

  return (
    <div css={cardStyle}>
      <div css={titleStyle}>{title}</div>
      <div css={valueContainerStyle}>
        <div css={currentMonthValueStyle}>{currentMonthValueDisplay}</div>
        <div css={[prevMonthContainerStyle, trendColorStyle]}>
          <span css={arrowStyle}>{trend === 'up' ? '⬆︎' : trend === 'down' ? '⬇︎' : ''}</span>
          <span css={prevMonthInfoStyle}>
            {t('PrevMonthComparison', { rate: '' }).trim()}
            <br />
            {`${momRateDisplay}(${prevMonthValue})`}
          </span>
        </div>
      </div>
    </div>
  )
}
